import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from './useAuthhandling';
import Cookies from 'js-cookie';
import Config from './Config';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import moment from "moment";

function Contactview() {

  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();

  const [contact, setContact] = useState([]);


  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/customer/contact-form/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();

      setContact(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  useEffect(() => {
      getinfo();
    }, []);
  return (
    <div className="container-scroller">
    <Navbar />

    <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
            <div className="content-wrapper">
                <div className='view_page_top'>
                    <Link to="/contactlist">Contact list</Link>
                </div>
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Contact View page</h4>

                                <div className='row view_div_row'>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Name </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {contact.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Email </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {contact.email}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Created Date </h6>
                                            </div>

                                            <div className='view_portion_p'>
                                                <p>{moment(contact.createdAt).utc().format("YYYY-MM-DD")}</p>
                                            </div>

                                        </div>
                                    </div>

                                    <div className='col-12 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Message </h6>
                                            </div>

                                            <div className='view_portion_p'>
                                                <p>  {contact.message}</p>
                                            </div>

                                        </div>
                                    </div>
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Contactview
